import type { FC } from 'react';
import React from 'react';

import type { IStickyTableRowProps } from '../models';
import { useTableContext } from '../../../sme-sticky-table';

export const StickyTableRow: FC<IStickyTableRowProps> = ({ Grid, alignment, children }) => {
    const columnsWidth = useTableContext();

    return (
        <Grid
            alignment={alignment}
            colAutoWidth
            collapse
            columnsWidth={columnsWidth}
            justify="start"
        >
            {children}
        </Grid>
    );
};
